import React from 'react';

import { EditOutlined } from '@ant-design/icons';
import ListPageHeader from '@shared/ListPageHeader';
import { Card, Descriptions, Tag, Table, Button } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useLoaderData, useNavigate } from 'react-router-dom';

export default function OrderPostProcessorsShow() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const record = useLoaderData();

  const validity = (!record.start_datetime && !record.end_datetime)
    ? t('common.always', 'Always')
    : `${record.start_datetime ? dayjs(record.start_datetime).format('YYYY-MM-DD HH:mm') : '∞'} ~ ${record.end_datetime ? dayjs(record.end_datetime).format('YYYY-MM-DD HH:mm') : '∞'}`;

  const rulesColumns = [
    {
      title: t('admin.pages.order_post_processors.fields.condition_type', 'Condition'),
      dataIndex: 'condition_type',
      key: 'condition_type',
      render: (text) => <Tag color="blue">{text}</Tag>
    },
    {
      title: t('admin.pages.order_post_processors.fields.operator', 'Operator'),
      dataIndex: 'operator',
      key: 'operator',
    },
    {
      title: t('admin.pages.order_post_processors.fields.value', 'Value'),
      dataIndex: 'value',
      key: 'value',
    },
    {
      title: t('admin.pages.order_post_processors.sections.actions', 'Actions'),
      key: 'actions',
      render: (_, record) => (
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          {record.order_post_processor_actions?.map((action, index) => (
            <li key={index}>
              <strong>{action.action_type}</strong>: {JSON.stringify(action.action_config)}
            </li>
          ))}
        </ul>
      )
    }
  ];

  const headerActions = (
    <Button type="primary" icon={<EditOutlined />} onClick={() => navigate(`/order_post_processors/${record.id}/edit`)}>
      {t('common.edit', 'Edit')}
    </Button>
  );

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['orders', 'orders.post_processors', { label: record.name }]}
        actions={headerActions}
      />

      <Card title={t('common.basic_info', 'Basic Info')} style={{ marginBottom: 16 }}>
        <Descriptions bordered column={2}>
          <Descriptions.Item label={t('admin.pages.order_post_processors.fields.name', 'Rule Name')}>
            {record.name}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.pages.order_post_processors.fields.active', 'Status')}>
            {record.active
              ? <Tag color="success">{t('common.enabled', 'Enabled')}</Tag>
              : <Tag color="default">{t('common.disabled', 'Disabled')}</Tag>
            }
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.pages.order_post_processors.fields.priority', 'Priority')}>
            {record.priority}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.pages.order_post_processors.fields.validity', 'Validity')}>
            {validity}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.pages.order_post_processors.fields.description', 'Description')} span={2}>
            {record.description || '-'}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title={t('admin.pages.order_post_processors.sections.rules', 'Rules & Actions')}>
        <Table
          dataSource={record.order_post_processor_rules || []}
          columns={rulesColumns}
          rowKey="id"
          pagination={false}
        />
      </Card>
    </div>
  );
}